const GLOBAL_THEME = '@CONFIG/GLOBAL_THEME'

const initialState = {
  theme: 'LIGHT_THEME'
}

export const setTheme = payload => {
  return {
    type: GLOBAL_THEME,
    payload
  }
}

export default (state = initialState, { type, payload }) => {
  return type === GLOBAL_THEME ? { ...state, theme: payload } : state
}
